export const SALES_FORCE_INITIAL_QUOTE_DATA_STATUS = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  UNSUPPORTED_SCENARIO: 'UNSUPPORTED_SCENARIO',
};
